import { ServiceWithSession } from './base-service';

export class GuestAccessService extends ServiceWithSession {
	async recordGuestPublicLinkLogin() {
		return this.serviceRequest({
			endpoint: 'svc/settings/guest-access/record-public-link-login',
			method: 'post'
		});
	}
}